<ng-http-loader [spinner]="spinkit.skSpinnerPulse"  [filteredUrlPatterns]="['getActiveDowntimeWindow', 'syncRedis']">
</ng-http-loader>
<app-prelogin *ngIf="!loggedIn"></app-prelogin>
<router-outlet></router-outlet>

<p-dialog header="Confirmation" [(visible)]="displayBasic" [autoZIndex]="true" [modal]="true">
    <p>Your session will expire in {{counter}} seconds.</p>
    <br>
    <p>Click on continue to stay in application else you will be logout.</p>
    <br>
    <div class="col form-footer">
        <button pButton autofocus label="Continue" type="button" class="ey-button-dark me-2 mt-0" (click)="continue()"
            style="margin-right: 30px;"></button>
        <button pButton label="Cancel" class="ey-secondary-dark me-2 mt-0" type="submit" (click)="cancel()"
            style="margin-right: 30px;"></button>
    </div>
</p-dialog>

<p-confirmDialog></p-confirmDialog>